import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { EBOOK_BLOCKS, EBOOK_FEATURES } from './salesData';
export function TomosSection() {
  return <section id="incluye" className="bg-cream py-14 sm:py-20" data-id="element-296" data-mp="1p5wmp5wnqrhh">
      <div className="mx-auto max-w-6xl px-5" data-id="element-297" data-mp="1u2564vhw16ug">
        <div className="text-center" data-id="element-298" data-mp="xcnrvs4uach5">
          <SectionTag data-id="element-299" data-mp="xdpg6yav8vgt">Qué incluye</SectionTag>
          <h2 className="mx-auto mt-4 max-w-[20ch] font-display text-[1.6rem] font-extrabold leading-[1.15] tracking-tight text-charcoal sm:max-w-[30ch] sm:text-[2.4rem]" data-id="element-300" data-mp="xeqsf63mbo04">
            Un ebook de 145 páginas que funciona como <span className="text-gold" data-id="element-301" data-mp="1bbvvcx81c6r5">sistema</span>, no
            como recetario.
          </h2>
        </div>

        <div className="mt-10 grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-id="element-302" data-mp="2hsr5lydttisu">
          {EBOOK_BLOCKS.map((block, i) => <motion.article key={block.num} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1],
          delay: Math.min(i, 3) * 0.05
        }} className="flex h-full flex-col rounded-3xl border border-stone bg-white p-6 shadow-[0_18px_40px_-30px_rgba(56,37,34,0.6)]" data-id="element-303" data-mp="2mq9andoq3dvk" data-mpi={i}>
              <div className="flex items-center justify-between gap-3" data-id="element-304" data-mp="27p4f6n46ukws">
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-sand font-display text-[1.1rem] font-extrabold text-gold" data-id="element-305" data-mp="27rh27eoszlgp">
                  {block.num}
                </span>
                <span className="font-display text-[0.6rem] font-bold uppercase tracking-editorial text-taupe" data-id="element-306" data-mp="1yuon6pyneajp">
                  {block.stage}
                </span>
              </div>
              <h3 className="mt-4 font-display text-[1.15rem] font-bold leading-snug tracking-tight text-charcoal sm:text-[1.25rem]" data-id="element-307" data-mp="1oy3k4a66v9ii">
                {block.title}
              </h3>
              <p className="mt-2 font-sans text-[0.87rem] leading-relaxed text-taupe" data-id="element-308" data-mp="1aal9kv5y3ko6">
                {block.outcome}
              </p>
              <ul className="mt-4 space-y-2 border-t border-stone pt-4" data-id="element-309" data-mp="11bhoxmr4qx7k">
                {block.points.map(p => <li key={p} className="flex gap-2.5 font-sans text-[0.83rem] leading-snug text-charcoal/85" data-id="element-310" data-mp="15cjqia8irlcp">
                    <span className="mt-1.5 h-1.5 w-1.5 shrink-0 rounded-full bg-coral" aria-hidden data-id="element-311" data-mp="1t509qo3ztjdl" />
                    {p}
                  </li>)}
              </ul>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-3xl bg-sand px-6 py-9 sm:px-10" data-id="element-312" data-mp="1ob5srsfrvii7">
          <h3 className="text-center font-display text-[1.25rem] font-bold tracking-tight text-charcoal sm:text-[1.6rem]" data-id="element-313" data-mp="2c1jopu1ha1i2">
            Cómo está hecho el material
          </h3>
          <ul className="mx-auto mt-6 grid max-w-3xl gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-314" data-mp="2gucqqa5kavqg">
            {EBOOK_FEATURES.map(f => <li key={f} className="flex gap-2.5 font-sans text-[0.87rem] leading-snug text-charcoal/85" data-id="element-315" data-mp="eg2y9dpyqm1">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-gold" aria-hidden strokeWidth={3} data-id="element-316" data-mp="f2axzwf7972a" />
                {f}
              </li>)}
          </ul>
        </div>

        <div className="mt-9 flex justify-center" data-id="element-317" data-mp="3ikkqwkqy0teq">
          <CTAButton className="w-full max-w-[26rem] px-4" data-id="element-318" data-mp="3dkq16kiwm9v9" />
        </div>
      </div>
    </section>;
}